<template>
  <div class="sample-information-view">
    <SampleInformationTabs />
  </div>
</template>

<script>
import SampleInformationTabs from "../components/layout/SampleInformation/SampleInformationTabs.vue";

export default {
  name: "SampleValidation",
  components: {
    SampleInformationTabs,
  },
};
</script>

<style scoped>
.sample-information-view {
  height: 100vh;
  overflow: hidden;
}
</style> 